import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const Email = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      d="M22.2474 5.96751C23.1373 9.72217 23.1373 13.6328 22.2474 17.3875C22.0619 17.9674 21.7297 18.4894 21.2829 18.903C20.836 19.3165 20.2899 19.6074 19.6974 19.7475C14.5692 20.5575 9.34561 20.5575 4.2174 19.7475C3.62493 19.6074 3.07875 19.3165 2.63194 18.903C2.18512 18.4894 1.85285 17.9674 1.6674 17.3875C0.777534 13.6328 0.777534 9.72217 1.6674 5.96751C1.85285 5.38763 2.18512 4.86557 2.63194 4.45205C3.07875 4.03853 3.62493 3.74759 4.2174 3.60751C9.34561 2.7975 14.5692 2.7975 19.6974 3.60751C20.2899 3.74759 20.836 4.03853 21.2829 4.45205C21.7297 4.86557 22.0619 5.38763 22.2474 5.96751V5.96751Z"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M2.95728 4.42719L10.5373 12.0472C10.7232 12.2346 10.9444 12.3834 11.1881 12.485C11.4318 12.5865 11.6933 12.6388 11.9573 12.6388C12.2213 12.6388 12.4827 12.5865 12.7264 12.485C12.9701 12.3834 13.1913 12.2346 13.3773 12.0472L20.9573 4.36719"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M9.61735 11.2173L2.78735 18.6373"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M14.1172 11.4473L21.3072 18.8673"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M12 9C12.5514 9 13 8.5514 13 8C13 7.4486 12.5514 7 12 7C11.4486 7 11 7.43925 11 8C11 8.5514 11.4486 9 12 9Z"
      fill="currentColor"
    />
  </Icon>
);

export default Email;
